import { z } from "zod";
import { FirestoreTimestampLooseSchema } from "./firestore.js";
const CustomerFeedbackSchema = z.object({
  choiceRating: z.number().describe("\uCC57\uBCF8 \uC0C1\uB2F4 \uD3C9\uAC00"),
  directRating: z.number().nullable().describe("\uC9C1\uC811 \uC0C1\uB2F4 \uD3C9\uAC00"),
  improvementText: z.string().nullable(),
  ticketId: z.string(),
  userId: z.string(),
  agentId: z.string().nullable(),
  agentName: z.string().nullable(),
  companyName: z.string().nullable(),
  createdAt: z.date()
  // tags: z.array(z.string()).nullable(),
});
const CreateCustomerFeedbackSchema = CustomerFeedbackSchema.omit({
  createdAt: true
});
const CustomerFeedbackSnapshotSchema = z.object({
  choiceRating: z.number().describe("\uCC57\uBCF8 \uC0C1\uB2F4 \uD3C9\uAC00"),
  directRating: z.number().nullable().describe("\uC9C1\uC811 \uC0C1\uB2F4 \uD3C9\uAC00"),
  improvementText: z.string().nullable(),
  userId: z.string(),
  companyName: z.string().nullable(),
  createdAt: FirestoreTimestampLooseSchema
});
export {
  CreateCustomerFeedbackSchema,
  CustomerFeedbackSchema,
  CustomerFeedbackSnapshotSchema
};
//# sourceMappingURL=feedback.js.map